import {
  HttpErrorResponse,
  HttpHandlerFn,
  HttpInterceptorFn,
  HttpRequest,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';

import { MessageService } from 'primeng/api';

/**
 * A 409 without a `field` means an optimistic-concurrency conflict (RowVersion/ConcurrencyStamp
 * mismatch) rather than a duplicate-value conflict (which the backend tags with `field` so the
 * form can show it inline instead - see ServerConflictError). This is the single place that
 * surfaces the "someone else already changed this" message, so every entity that adds
 * concurrency protection on the backend gets consistent UI feedback for free, without each
 * feature's state service needing to special-case it.
 */
export const concurrencyConflictInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
) => {
  const messageService = inject(MessageService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 409 && !error.error?.field) {
        messageService.add({
          severity: 'warn',
          summary: 'Conflicto de edición',
          detail:
            error.error?.detail ??
            'Este registro fue modificado por otro usuario. Actualiza la página para ver los cambios más recientes.',
          life: 8000,
        });
      }

      return throwError(() => error);
    }),
  );
};
